import { motion } from "motion/react"

import type { InvoiceTab } from "@atlant/agent-contract"
import { Badge } from "@atlant/ui"

export interface InvoiceTabItem {
  value: InvoiceTab
  label: string
  badge?: number
}

interface InvoiceTabsProps {
  tabs: InvoiceTabItem[]
  value: InvoiceTab
  onChange: (value: InvoiceTab) => void
  layoutId?: string
}

export const InvoiceTabs = ({
  tabs,
  value,
  onChange,
  layoutId = "invoices-tab-indicator",
}: InvoiceTabsProps) => (
  <nav className="border-b">
    <div role="tablist" className="flex gap-4">
      {tabs.map((tab) => {
        const isActive = value === tab.value

        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.value)}
            className="hover:text-foreground text-muted-foreground data-[active=true]:text-foreground relative py-2 text-sm font-medium transition-colors"
            data-active={isActive}
          >
            <span className="flex items-center gap-1.5">
              {tab.label}
              {tab.badge != null && tab.badge > 0 && (
                <Badge className="size-5 justify-center rounded-full px-0 text-[10px]">
                  {tab.badge}
                </Badge>
              )}
            </span>
            {isActive && (
              <motion.div
                layoutId={layoutId}
                className="bg-primary absolute right-0 bottom-0 left-0 h-0.5"
                transition={{ type: "spring", stiffness: 500, damping: 35 }}
              />
            )}
          </button>
        )
      })}
    </div>
  </nav>
)
